import { Injectable, Injector } from "@angular/core";
import {
	HttpInterceptor,
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpErrorResponse,
	HttpResponse,
} from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { UserRightsService } from "../user-rights/user-rights.service";

@Injectable({
	providedIn: "root",
})
export class InterceptorService implements HttpInterceptor {
	constructor(private _injector: Injector, private toastService: ToastrService, private auth: UserRightsService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			tap((evt) => {
				if (evt instanceof HttpResponse) {
					// if(evt.body && evt.body.success)
					// this.toasterService.success(evt.body.success.message, evt.body.success.title, { positionClass: 'toast-bottom-center' });
				}
				return of(evt);
			}),
			catchError((err: HttpErrorResponse) => {
				if (err instanceof HttpErrorResponse) {
					// console.log("ERROR!!!", err.status);
					switch (err.status) {
						case 0: // Unknown Error
							this.toastService.error(
								"Could not establish a connection to the API.",
								"Network Unreachable",
								{timeOut: 4000},
							);
							// let _router = this._injector.get(Router);
							this.auth.Logout();
							// _router.navigate(["/"]);
							break;
            case 500: // Internal Server Error
              // This is because we don't want to show a toast with the SNMP settings response, or with WAN/LAN data parsing errors
              if (!err.error.message.includes("settings response HTTP code is not 200") && !err.error.message.includes("failed to get devices WAN data: cannot parse JSON: cannot parse object") && !err.error.message.includes("failed to get devices LAN data: cannot parse JSON: cannot parse object")) {
                this.toastService.error(err.error.message, err.status + " " + err.statusText, { timeOut: 4000 });
              }
							break;
						case 420: // User Required to Login Again
							this.toastService.error( err.error.message, err.statusText, {timeOut: 4000});
							this.auth.Logout();
							break;
						case 417: // Expectation Failer Error
							this.toastService.error( err.error.message, err.status + " " + err.statusText, {timeOut: 4000});
							break;
						default:
							if (err.error != null) {
								this.toastService.error(err.error.message, err.status + " " + err.statusText, {timeOut: 4000} );
							}
							break;
					}
				}
				return throwError(err);
			}),
		);
	}
}
